<template>
    <div class="prices">
        <div v-if="hasSpecialPrice" class="special-prices">
            <div class="discounted-price">
                {{ app.formatPrice(prices.unit_price, app.storefrontContext?.currency?.isoCode) }}
            </div>
            <div class="old-price">
                {{ app.formatPrice(prices.list_price.price, app.storefrontContext?.currency?.isoCode) }}
            </div>
        </div>
        <div v-else class="regular-price">
            {{ app.formatPrice(prices.unit_price, app.storefrontContext?.currency?.isoCode) }}
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    props: {
        product: {
            type: Object,
            default() {
                return null;
            }
        },
    },
    data() {
       return {
           app: useAppStore(),
       };
    },
    computed: {
        prices() {
            return this.product?.calculated_prices?.[0] || this.product?.calculated_price;
        },
        hasSpecialPrice() {
            return this.prices.list_price;
        },
    },
});
</script>
<style scoped>
.special-prices {
    display: flex;
    gap: 8px;

    .old-price {
        font-size: 11px;
        opacity: 0.5;
        text-decoration-line: line-through;
    }

    .discounted-price {
        color: #e65f5f;
    }
}
</style>
